import React from 'react';
import { MoreHorizontal, Calendar } from 'lucide-react';
import MainPanel from '../../components/layout/MainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';
import { formatRelativeTime } from '../../utils/workspaceFormat';

export default function BonnieFAQs() {
  const { data } = useDashboardData();
  const { locale, t } = useLocale();
  const faqs = data?.bonnie?.faqs || [];
  const subtitle = faqs[0]?.sourceLabel || t('bonnie.subtitleFallback');
  const len = faqs.length;

  return (
    <MainPanel
      title={t('bonnie.faqsTitle')}
      subtitle={subtitle}
      actions={
        <button type="button" className="custio-btn-primary">
          {t('bonnie.createFaq')}
        </button>
      }
    >
      {faqs.length === 0 ? (
        <div className="custio-empty" style={{ paddingTop: 24 }}>
          <p className="custio-empty__title">{t('bonnie.emptyFaqs')}</p>
          <p style={{ fontSize: 14, margin: 0, color: '#9ca3af' }}>{t('bonnie.emptyFaqsBody')}</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {faqs.map((f) => (
            <div
              key={f.id}
              style={{
                background: '#1f2229',
                borderRadius: 12,
                padding: '18px 20px',
                color: '#f3f4f6',
                border: '1px solid rgba(255,255,255,0.06)',
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>{f.question}</h3>
                <button type="button" style={{ background: 'none', border: 'none', color: '#9ca3af', cursor: 'pointer' }} aria-label={t('common.more')}>
                  <MoreHorizontal size={20} />
                </button>
              </div>
              <p style={{ margin: '10px 0 0', fontSize: 14, color: '#9ca3af' }}>{f.answer}</p>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16, fontSize: 12, color: '#6b7280' }}>
                <span>{f.sourceLabel}</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <Calendar size={14} />
                  {formatRelativeTime(f.updatedAt || f.createdAt, locale)}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
      {faqs.length > 0 && (
        <p style={{ textAlign: 'center', marginTop: 24, fontSize: 13, color: '#9ca3af' }}>
          {t('bonnie.showingItems', { from: 1, to: len, total: len })}
        </p>
      )}
    </MainPanel>
  );
}
